import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';

import { baseTheme } from '../../theme';

import { sendEmailVerification } from '../../services/auth/service';
import SubmitButton from '../../components/form-elements/submit-button';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        paddingTop: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
      },
      mainHeading: {
        paddingBottom: theme.spacing(4),
      },
      contentRoot: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      headerSpacing: {
        marginBottom: theme.spacing(1),
      },
      buttonContainer: {
        width: '10%',
      },
      submitButton: {
        fontSize: '1em',
      },
    }),
);

export default function UnVerifiedPage() {
  const classes = useStyles(baseTheme);

  return (
      <Grid item container direction="column" className={classes.root}>
          <Grid item className={classes.mainHeading}>
              <Typography variant="h6" color="primary">
                  Step 1: Please check your email to verify your Reliht
                  account before getting started.
              </Typography>
              <Typography variant="h6" color="primary">
                  Step 2: Refresh this page.
              </Typography>
              <Typography variant="h6" color="primary">
                  Step 3: Click on “Posts” in top purple nav bar to get started.
              </Typography>
          </Grid>

          <Grid item xs={6}>

                  <Grid item xs={12} className={classes.contentRoot}>
                      <Typography variant="h5" color="primary" className={classes.headerSpacing}>
                          Resend Verification
                      </Typography>
                      Click to resend verification email for this account.
                      Once your account is verified, please log in again.
                      <div className={classes.buttonContainer}>
                          <SubmitButton
                              className={classes.submitButton}
                              onClick={sendEmailVerification}
                              text="Resend Verification"
                              variant="dark"
                          />
                      </div>
                  </Grid>
              </Grid>
      </Grid>
  );
}
